import type { UploadOptions } from '../s3'

export interface CloudinaryUploadResponse {
  public_id?: string
  version?: number
  signature?: string
  width?: number
  height?: number
  format?: string
  resource_type?: string
  created_at?: string
  tags?: string[]
  bytes?: number
  pages?: number
  type?: string
  etag?: string
  placeholder?: boolean
  url?: string
  secure_url?: string
  overwritten?: boolean
  original_filename?: string
  original_extension?: string
}

const CLOUD_NAME = process.env.CLOUDINARY_CLOUD_NAME
const UPLOAD_PRESET = process.env.CLOUDINARY_UPLOAD_PRESET

export async function cloudinaryUploadFile(file: File, opts: UploadOptions): Promise<CloudinaryUploadResponse> {
  const formData = new FormData()
  const { companyId, docId, tags = [] } = opts

  // #22526: backstop for direct callers that bypass `uploadFile`'s guard. `formData.append` coerces with
  // `String()`, so a missing companyId here becomes a folder literally named `undefined` — an asset with
  // no recorded owner, which the migration's ownership guard can then never purge. Line 38 below already
  // guards the `company-` tag the same way; the folder was the one place that did not.
  if (!companyId) {
    throw new Error('cloudinaryUploadFile: companyId is required — refusing to upload to an "undefined" folder')
  }

  formData.append('file', file)
  formData.append('upload_preset', UPLOAD_PRESET)
  formData.append('folder', companyId)

  formData.append(
    'tags',
    [companyId && `company-${companyId}`, docId && `doc-${docId}`, ...tags].filter(Boolean).join(',')
  )

  const data = await fetch(`https://api.cloudinary.com/v1_1/${CLOUD_NAME}/auto/upload`, {
    method: 'POST',
    body: formData
  }).then((res) => res.json())

  return data
}
